import { JWToken } from "@/interfaces";

export function decodeJWT(token: string): JWToken {
  return JSON.parse(atob((token as string).split('.')[1]))
}
